import distanceInWordsStrict from 'date-fns/distance_in_words_strict'

const durationInWords = (s, locale) => distanceInWordsStrict(0, s * 1000, { locale })

export default durationInWords
